import { setCandidateId } from '../tracking/tealium';
import { useUserProfile } from './useUserProfile';

export const useSetCandidateId = () => {
  const { user } = useUserProfile();

  if (user) {
    setCandidateId(user.id, user.emailCorrelationId);
  }
};
